import { createIcon } from '@chakra-ui/react';

export const TagBoldIcon = createIcon({
  displayName: 'TagBoldIcon',
  path: (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        // width="25"
        // height="24"
        viewBox="0 0 25 24"
        fill="none"
      >
        <path
          d="M20.3305 8.6998L15.8005 4.1698C14.8505 3.2198 13.5405 2.7098 12.2005 2.7798L7.20046 3.0198C5.20046 3.1098 3.61046 4.6998 3.51046 6.6898L3.27046 11.6898C3.21046 13.0298 3.71046 14.3398 4.66046 15.2898L9.19046 19.8198C11.0505 21.6798 14.0705 21.6798 15.9405 19.8198L20.3305 15.4298C22.2005 13.5798 22.2005 10.5598 20.3305 8.6998ZM10.0005 12.3798C8.41046 12.3798 7.12046 11.0898 7.12046 9.4998C7.12046 7.9098 8.41046 6.6198 10.0005 6.6198C11.5905 6.6198 12.8805 7.9098 12.8805 9.4998C12.8805 11.0898 11.5905 12.3798 10.0005 12.3798Z"
          fill="#6E6789"
        />
      </svg>
    </>
  ),
});
